<!-- =========================================================================================
  File Name: VehicleCreate.vue
  Description: Vehicle Create Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div v-if="vehicleCreatePermission" id="page-user-edit">
		<vx-card>
			<vehicle-create-tab-account class="mt-4" :data="{}" />
		</vx-card>
	</div>
	<not-permission v-else></not-permission>
</template>

<script>
import NotPermission from "@/views/pages/NotPermission.vue";
import VehicleCreateTabAccount from "./VehicleCreateTabAccount.vue";

export default {
	components: {
		NotPermission,
		VehicleCreateTabAccount,
	},
	computed: {
		vehicleCreatePermission() {
			return this.$store.getters.checkPermission("VEHICLE_C");
		},
	},
};
</script>

<style lang="scss" scoped>
#page-user-edit {
	height: 30%;
}
</style>
